module.exports = __webpack_public_path__ + "img/menu-bonus.6badb16e.svg";